const pathUtils = {
  getContextPath: function (path) {
    let getContextPath = window['getContextPath']
    path = path || ''
    if (getContextPath) {
      return getContextPath() + path
    } else {
      return path
    }
  }
}

export default pathUtils



// WEBPACK FOOTER //
// ./src/util/pathUtils.js